import React, {useEffect, useState} from "react";
import DefaultPageHeader from "../../../containers/DefaultPageHeader";
import DefaultTableCard from "../../../containers/DefaultTableCard";
import {ApiService} from "../../../services/ApiService";
import {Button, Popconfirm, Space, Spin} from "antd";
import {DeleteOutlined, EditOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import TableLongText from "../../../containers/TableLongText";
import {useNavigate} from "react-router-dom";

const ReligionCountListPage = () => {
    const navigation = useNavigate()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const requestData = () => {
        setLoading(true)
        ApiService.admin.regionStatistics.list()
            .onSuccess(setData)
            .onComplete(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        requestData()
    }, []);

    const handleHeaderButtonClick = (event, key) => {
        navigation("/region_statistics/edit")
    }

    const handleItemEdit = (event, item) => {
        navigation("/region_statistics/edit?code=" + item.code + "&pcode=" + item.parentCode)
    }

    const handleItemDelete = (event, item) => {
        ApiService.admin.religion.venue.remove(item.guid)
            .onSuccess(() => {
                const content = data.content.filter(i => item.guid !== i.guid)
                setData({
                    ...data,
                    content: content
                })
            })
    }

    const tableColumns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            width: 60,
        },
        {
            title: '地区',
            dataIndex: 'name',
            key: 'name',
            render: (text) => (<TableLongText text={text}/>)
        },
        {
            title: '宗教场所',
            dataIndex: '宗教场所',
            key: '宗教场所',
            render: (text, record) => (<TableLongText text={record.properties["宗教场所"]}/>)
        },
        {
            title: '港澳台同胞',
            dataIndex: '港澳台同胞',
            key: '港澳台同胞',
            render: (text, record) => (<TableLongText text={record.properties["港澳台同胞"]}/>)
        },
        {
            title: '党派人士',
            dataIndex: '党派人士',
            key: '党派人士',
            render: (text, record) => (<TableLongText text={record.properties["党派人士"]}/>)
        },
        {
            title: '无党派代表人士',
            dataIndex: '无党派代表人士',
            key: '无党派代表人士',
            render: (text, record) => (<TableLongText text={record.properties["无党派代表人士"]}/>)
        },
        {
            title: '工商联会员',
            dataIndex: '工商联会员',
            key: '工商联会员',
            render: (text, record) => (<TableLongText text={record.properties["工商联会员"]}/>)
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 88,
            render: (text, record) => (
                <Space size='small'>
                    <Button type='primary' size={'small'} icon={<EditOutlined/>}
                            onClick={event => handleItemEdit(event, record)}/>
                </Space>
            )
        },
    ]

    return (
        <Spin spinning={loading}>
            <DefaultPageHeader
                title="各地数据统计"
            />

            <DefaultTableCard
                columns={tableColumns}
                data={data ?? []}
                loading={false}
            />
        </Spin>
    )
}

export default ReligionCountListPage